import "antd/dist/antd.css";
import React, { useState, useEffect, useReducer } from "react";
import { Row, Col, Button, Card, Spin } from "antd";
import { initialState, reducer } from "./reducer";
import { useSelector } from "react-redux";
import SimpleHeader from "../../../helpers/cards-helper/SimpleHeader";
import { getErrorMessage } from "../../../helpers/ErrorHelper";
import ObserverService from "../../../services/Election/ObserverService";
import { ErrorCard } from "../Patronage/PatronageReferred/voters-list/components/List";
import VotersList from "./components/VotersList";
import { setRowNumber } from "../../../helpers/MainHelper";



function sleep(milliseconds) {
    return new Promise((resolve) => setTimeout(resolve, milliseconds));
}



const formatVoters = (voters) => {
    return voters?.map((voter) => {
        return {
            ...voter,
            voted: voter?.voted ? true : false,
            isSent: voter?.isSent === true || voter?.isSent === false ? voter?.isSent : null,
        };
    });
};


const updateItems = (dispatch, qvs, voters) => {
    const action = {
        type: "set_items",
        payload: {
            qvs: qvs,
            voters: formatVoters(voters),
        }
    };
    dispatch(action);
};



const ObserverModule = () => {
    const [state, dispatch] = useReducer(reducer, initialState);
    const observer = useSelector((state) => state.Member.observer);
    const token = useSelector((state) => state.Member.token);
    const [errorMessage, setErrorMessage] = useState(null);


    const setVoterSent = (voterId) => {
        const action = {
            type: 'set_voter_sent',
            payload: voterId
        }
        dispatch(action);
    };


    const notSentVoters = state.voters?.filter((voter) => voter?.isSent === false);


    const updateVoter = async (voter) => {
        await sleep(1000);
        const requestData = {
            observer_id: observer?.observer_id,
            voter_id: voter?.voter_id,
        };

        const hasVoted = voter?.voted;
        if (hasVoted) {
            ObserverService.confirmVote(token, requestData)
                .then((response) => {
                    setVoterSent(voter?.voter_id);
                })
                .catch((err) => { });
        } else {
            ObserverService.deleteVote(token, requestData)
                .then((response) => {
                    setVoterSent(voter?.voter_id);
                })
                .catch((err) => { });
        }
    };


    useEffect(() => {
        const updateVotersAsync = async () => {
            for (const voter of notSentVoters) {
                await updateVoter(voter);
            }
        };
        const intervalCall = setInterval(updateVotersAsync, 60000);
        return () => {
            clearInterval(intervalCall);
        };
    }, [notSentVoters]);


    useEffect(() => {
        if (observer) {
            updateLoading(true);
            ObserverService.getList()
                .then((response) => {
                    const apiResponse = response.data;
                    const updatedQvs = apiResponse.qvs;
                    const updatedVoters = apiResponse.voters;
                    updateItems(dispatch, updatedQvs, updatedVoters);
                    setErrorMessage(null);
                    updateLoading(false);
                })
                .catch((error) => {
                    const errorMessage = getErrorMessage(error);
                    updateItems(dispatch, [], []);
                    setErrorMessage(errorMessage);
                    updateLoading(false);
                });
        } else {
            setErrorMessage("Ju nuk keni të drejta të aksesoni këtë modul të sistemit!");
        }
    }, [observer]);


    const updateLoading = (isLoading) => {
        const action = {
            type: "set_loading",
            payload: isLoading,
        };
        dispatch(action);
    };


    const refreshList = () => {
        const action = {
            type: "refresh_list",
        };
        dispatch(action);
    };


    const updateIndexVisibility = (indexVisibility) => {
        const action = {
            type: "set_index_visibility",
            payload: indexVisibility,
        };
        dispatch(action);
    };


    const openVoters = (qv) => {
        const viewAction = {
            type: "open_view",
            payload: {
                qv: qv,
                index: 1
            }
        };
        dispatch(viewAction);

        const updatedQVvoters = state.voters.filter((voter) => voter?.qv_id === qv?.id);
        const qvAction = {
            type: "set_qv_voters",
            payload: setRowNumber(updatedQVvoters)
        }
        dispatch(qvAction);
    };


    const updateSearchFilters = (requestFilters) => {
        const action = {
            type: "set_search_filters",
            payload: requestFilters
        };
        dispatch(action);
    };


    const onSuccess = () => {
        refreshList();
        updateIndexVisibility(0);
    };


    const onBack = () => {
        updateSearchFilters({});
        updateIndexVisibility(0);
    };


    return (
        <Row gutter={24} className="page-content">
            <Col span={24}>

                {state.indexVisibility === 0 && (
                    <Row gutter={24}>
                        <Col span={24}>
                            <SimpleHeader
                                title={"Dita e Votimit"}
                            />
                        </Col>
                    </Row>
                )}

                {state.indexVisibility === 0 && (
                    <Row gutter={24} className="mt-4">
                        <Col span={24}>

                            {state.isLoading === true && (
                                <Row gutter={24}>
                                    <Col span={24}>
                                        <Card>
                                            <Row gutter={24} className="p-5">
                                                <Col span={24} className="text-center">
                                                    <Spin tip="Ju lutem prisni!" size="large" />
                                                </Col>
                                            </Row>
                                        </Card>
                                    </Col>
                                </Row>
                            )}

                            {state.isLoading === false && (
                                <Row gutter={24}>
                                    <Col span={24}>

                                        {errorMessage !== null && (
                                            <Row gutter={24}>
                                                <Col span={24}>
                                                    <Card>
                                                        <ErrorCard
                                                            message={errorMessage}
                                                        />
                                                    </Card>
                                                </Col>
                                            </Row>
                                        )}

                                        {errorMessage === null && (
                                            <Row gutter={24}>
                                                <Col span={24}>
                                                    <Row gutter={24}>

                                                        {state.qvs?.map((qv, index) => (
                                                            <Col xl={4} lg={6} md={8} sm={12} xs={24} key={index + 1} className="mb-4">
                                                                <Button
                                                                    block
                                                                    type="primary"
                                                                    style={{ height: "50px" }}
                                                                    onClick={() => openVoters(qv)}
                                                                >
                                                                    <h5 className="m-0 p-0 font-weight-bold" style={{ color: "#fff" }}>{qv?.code}</h5>
                                                                </Button>
                                                            </Col>
                                                        ))}

                                                    </Row>
                                                </Col>
                                            </Row>
                                        )}

                                    </Col>
                                </Row>
                            )}

                        </Col>
                    </Row>
                )}

                {state.indexVisibility === 1 && (
                    <Row gutter={24}>
                        <Col xl={15} lg={15} md={24} sm={24} xs={24}>
                            <VotersList
                                dispatch={dispatch}
                                qv={state.selectedQV}
                                voters={state.qvVoters}
                                allVoters={state.voters}
                                isLoading={state.isLoading}
                                initialFilters={state.filters.searchFilters}
                                onSuccess={onSuccess}
                                onBack={onBack}
                            />
                        </Col>
                    </Row>
                )}

            </Col>
        </Row>
    );
};


export default ObserverModule;